import React from 'react';

const Footer = () => {
	return (
		<footer className='bg-gray-800 pb-4  text-white'>
			<div className='text-center'>{new Date().getFullYear()}</div>
		</footer>
	);
};

export default Footer;
